import { ResourceType } from './ResourceType';
import { TextureResource } from './TextureResource';
import { ShaderResource } from './ShaderResource';
import { BufferResource } from './BufferResource';
import { ProgramResource } from './ProgramResource';
export class ResourceManager {
    constructor(gl) {
        this.resources = new Map();
        this.gl = gl;
    }
    createResource(type, key = null, param = -1) {
        if (this.resources.has(key)) {
            return this.resources.get(key);
        }
        if (key == null) {
            ResourceManager.id += 1;
            key = '' + ResourceManager.id;
        }
        let resource;
        switch (type) {
            case ResourceType.Texture:
                resource = new TextureResource(this.gl);
                break;
            case ResourceType.Shader:
                resource = new ShaderResource(this.gl, param);
                break;
            case ResourceType.Buffer:
                resource = new BufferResource(this.gl);
                break;
            case ResourceType.Program:
                resource = new ProgramResource(this.gl);
                break;
        }
        this.resources.set(key, resource);
        return resource;
    }
    deleteResource(key) {
        if (this.resources.has(key)) {
            this.resources.get(key).delete();
            this.resources.delete(key);
        }
    }
    clearResources() {
        this.resources.forEach((value) => {
            value.delete();
        });
        this.resources.clear();
    }
}
ResourceManager.id = -1; // I want to make ABSOLUTELY SURE that no two id's are the same
//# sourceMappingURL=ResourceManager.js.map